import { render, staticRenderFns } from "./CopTestParameterList.vue?vue&type=template&id=4fa71f3c&scoped=true&"
import script from "./CopTestParameterList.vue?vue&type=script&lang=js&"
export * from "./CopTestParameterList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa71f3c",
  null
  
)

export default component.exports